import { put, takeEvery } from 'redux-saga/effects';
import { actions } from './index';

/** Worker Sagas */
export function* add(action) {
  yield put(actions.addToHistory(action.payload));
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* routerHistorySaga() {
  yield takeEvery('@@router/LOCATION_CHANGE', add);
}
export default routerHistorySaga;
